module.exports = __webpack_public_path__ + "static/img/world.7645ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/world.png
// module id = 6tUB
// module chunks = 2